import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getOrders, ordersSelector } from 'src/store/orders';

import { REACT_APP_API_URL } from 'src/constants';

import { WhiteCard } from 'src/components';

import { GreenArrowRight } from 'src/assets';
import './popularExchange.scss';

export const PopularExchange = () => {
  const { t } = useTranslation('popularExchange');

  const dispatch = useDispatch();

  const orders = useSelector(ordersSelector);

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch]);

  return (
    <div className="popular-exchange">
      <WhiteCard>
        <h3 className="popular-exchange__title">{t('title')}</h3>

        <div className="popular-exchange__content">
          {orders?.map((item, index) => (
            <div key={index} className="popular-exchange__item">
              <img
                className="popular-exchange__item__image"
                src={REACT_APP_API_URL + item?.given?.image}
                alt={item?.given?.image}
              />
              <div className="popular-exchange__item__title">
                {item?.given?.name}{' '}
                <span className="popular-exchange__item__currency">({item?.given?.code})</span>
              </div>
              <img
                src={GreenArrowRight}
                alt={GreenArrowRight}
                className="popular-exchange__item__arrow"
              />
              <img
                className="popular-exchange__item__image"
                src={REACT_APP_API_URL + item?.received?.image}
                alt={item?.received?.image}
              />
              <div className="popular-exchange__item__title">
                {item?.received?.name}{' '}
                <span className="popular-exchange__item__currency">({item?.received?.code})</span>
              </div>
            </div>
          ))}
        </div>
      </WhiteCard>
    </div>
  );
};
